<template>
  <v-card class="dialog-card">
    <v-dialog
      max-width="400"
      v-model="delete_dialog">
      <v-card
        v-if="delete_dialog"
        class="dialog-card">
        <div class="pa-3">
          <ModalHeader
            icon="mdi-alert"
            modalTitle="Are you sure?"
            @close="delete_dialog = false" />
        </div>
        <div
          class="mx-3 pa-3"
          style="background: rgba(0, 0, 0, 0.06); border-radius: 5px">
          <v-card-text>
            This action is irreversible, are you sure you want to delete?
          </v-card-text>
        </div>

        <div class="modal-footer">
          <v-btn
            @click="delete_dialog = false"
            variant="flat">
            <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
            back
          </v-btn>
          <v-spacer />
          <v-btn
            @click="DeleteRole()"
            :loading="delete_loading"
            variant="flat"
            dark
            style="background-color: var(--inner-background)">
            <v-icon style="font-size: 22px">mdi-trash-can</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ModalHeader
      helpFileName="CreateEditRole"
      icon="mdi-account-plus"
      :modalTitle="'Create Custom Role'"
      @close="emit('close')" />
    <div
      :class="'mx-3 py-3 px-4'"
      style="
        min-height: 300px;
        border-radius: 5px;
        overflow: auto;
        max-height: 400px;
      ">
      <v-text-field
        filled
        background-color="textBoxBackground"
        label="Name"
        v-model="name"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        style="height: 66px"></v-text-field>
      <v-text-field
        filled
        background-color="textBoxBackground"
        label="Description"
        v-model="description"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        style="height: 66px"></v-text-field>
      <v-checkbox
        density="compact"
        hide-details
        v-for="perm in permissions"
        :key="perm"
        :label="perm.name"
        v-model="perm.enabled"></v-checkbox>
    </div>

    <div class="modal-footer">
      <v-btn
        v-if="current_role"
        @click="delete_dialog = true"
        color="#db655c"
        style="color: white"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-trash-can</v-icon>
        Delete
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="!current_role"
        @click="CreateNewRole()"
        :loading="save_loading"
        color="primary"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Create
      </v-btn>
      <v-btn
        v-else
        @click="SaveExistingRole()"
        :loading="save_loading"
        color="primary"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { onMounted, ref, defineProps, onBeforeMount } from 'vue';
import { $http } from '../../stores/http.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
const props = defineProps(['current_role']);
const save_loading = ref(false);
const emit = defineEmits(['close']);
const name = ref('');
const description = ref('');
const permissions = ref([]);
const delete_dialog = ref(false);
onBeforeMount(async () => {
  permissions.value = JSON.parse(await $http('GET', '/get_permissions'));
  if (props.current_role) {
    name.value = props.current_role.name;
    description.value = props.current_role.description;

    for (const perm of props.current_role.permissions) {
      for (const existing_perm of permissions.value) {
        if (existing_perm.access_string === perm) {
          existing_perm.enabled = true;
          break;
        }
      }
    }
  }
});
async function DeleteRole() {
  await $http('DELETE', '/delete_role?uid=' + props.current_role.uid);
}
async function SaveExistingRole() {
  save_loading.value = true;
  let uid_list = [];
  for (const perm of permissions.value) {
    if (perm.enabled) {
      uid_list.push(perm.uid);
    }
  }
  await $http(
    'PUT',
    '/edit_role?uid=' + props.current_role.uid,
    JSON.stringify({
      name: name.value,
      description: description.value,
      permissions: uid_list,
    })
  );
  save_loading.value = false;
  emit('close');
}
async function CreateNewRole() {
  save_loading.value = true;
  let uid_list = [];
  for (const perm of permissions.value) {
    if (perm.enabled) {
      uid_list.push(perm.uid);
    }
  }
  await $http(
    'POST',
    '/create_role',
    JSON.stringify({
      name: name.value,
      description: description.value,
      permissions: uid_list,
    })
  );
  save_loading.value = false;
  emit('close');
}
</script>
